import { render, staticRenderFns } from "./ProcessingSoldGoodsMainSection.vue?vue&type=template&id=20e67062"
import script from "./ProcessingSoldGoodsMainSection.vue?vue&type=script&lang=js"
export * from "./ProcessingSoldGoodsMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports